var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPayment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "2em",
    height: "2em",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71603 4.59625C3.27327 5.00738 2.97674 5.67448 2.97674 6.72093V11.2791C2.97674 12.3255 3.27327 12.9926 3.71603 13.4038C4.16535 13.821 4.84231 14.0465 5.74419 14.0465H12.2558C13.1577 14.0465 13.8347 13.821 14.284 13.4038C14.7267 12.9926 15.0233 12.3255 15.0233 11.2791V6.72093C15.0233 5.67448 14.7267 5.00738 14.284 4.59625C13.8347 4.17903 13.1577 3.95349 12.2558 3.95349H5.74419C4.84231 3.95349 4.16535 4.17903 3.71603 4.59625ZM3.05141 3.8805C3.74163 3.23958 4.69258 2.97675 5.74419 2.97675H12.2558C13.3074 2.97675 14.2584 3.23958 14.9486 3.8805C15.6454 4.5275 16 5.48831 16 6.72093V11.2791C16 12.5117 15.6454 13.4725 14.9486 14.1195C14.2584 14.7604 13.3074 15.0233 12.2558 15.0233H5.74419C4.69258 15.0233 3.74163 14.7604 3.05141 14.1195C2.35463 13.4725 2 12.5117 2 11.2791V6.72093C2 5.48831 2.35463 4.5275 3.05141 3.8805Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 7.53491C8.19087 7.53491 7.53491 8.19087 7.53491 9.00003C7.53491 9.80919 8.19087 10.4651 9.00003 10.4651C9.80919 10.4651 10.4651 9.80919 10.4651 9.00003C10.4651 8.19087 9.80919 7.53491 9.00003 7.53491ZM6.55817 9.00003C6.55817 7.65142 7.65142 6.55817 9.00003 6.55817C10.3486 6.55817 11.4419 7.65142 11.4419 9.00003C11.4419 10.3486 10.3486 11.4419 9.00003 11.4419C7.65142 11.4419 6.55817 10.3486 6.55817 9.00003Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76742 6.88373C5.03715 6.88373 5.2558 7.10238 5.2558 7.3721V10.6279C5.2558 10.8976 5.03715 11.1163 4.76742 11.1163C4.4977 11.1163 4.27905 10.8976 4.27905 10.6279V7.3721C4.27905 7.10238 4.4977 6.88373 4.76742 6.88373Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2326 6.88373C13.5023 6.88373 13.7209 7.10238 13.7209 7.3721V10.6279C13.7209 10.8976 13.5023 11.1163 13.2326 11.1163C12.9629 11.1163 12.7442 10.8976 12.7442 10.6279V7.3721C12.7442 7.10238 12.9629 6.88373 13.2326 6.88373Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayment);
export default ForwardRef;